export default "__VITE_ASSET__C_njFw7B__"